// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGlkPSJMYXllcl8xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA2NCA2NDsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMxMzQ1NjM7fQo8L3N0eWxlPjxnPjxnIGlkPSJJY29uLUNsb2NrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNzguMDAwMDAwLCA0MjguMDAwMDAwKSI+PHBhdGggY2xhc3M9InN0MCIgZD0iTS0zNDYuMS0zNzMuMWMtMTIuNiwwLTIyLjktMTAuMy0yMi45LTIyLjljMC0xMi42LDEwLjMtMjIuOSwyMi45LTIyLjkgICAgIGMxMi42LDAsMjIuOSwxMC4zLDIyLjksMjIuOUMtMzIzLjEtMzgzLjQtMzMzLjQtMzczLjEtMzQ2LjEtMzczLjFMLTM0Ni4xLTM3My4xeiBNLTM0Ni4xLTQxNi41Yy0xMS4zLDAtMjAuNCw5LjItMjAuNCwyMC40ICAgICBzOS4yLDIwLjQsMjAuNCwyMC40czIwLjQtOS4yLDIwLjQtMjAuNFMtMzM0LjgtNDE2LjUtMzQ2LjEtNDE2LjVMLTM0Ni4xLTQxNi41eiIgaWQ9IkZpbGwtMTMxIi8+PHBvbHlsaW5lIGNsYXNzPSJzdDAiIGlkPSJGaWxsLTEzMiIgcG9pbnRzPSItMzM4LjksLTM4NC4zIC0zNDcuNCwtMzkyLjggLTM0Ny40LC00MDguMyAtMzQ0LjcsLTQwOC4zIC0zNDQuNywtMzkzLjkgICAgICAtMzM3LC0zODYuMiAtMzM4LjksLTM4NC4zICAgICIvPjwvZz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ClockPicker CSS start */
.kore-chat-window .clockPickerContainer .sdkFooterIcon.clock {
  opacity: 0;
}

.kore-chat-window .sdkFooterIcon.clock .sdkClock.clockBtn .clock {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
  margin: -4px;
  display: block;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover {
  width: 100%;
  position: relative;
  top: auto;
  left: auto;
  margin: 0 auto;
  border: 0;
  background: transparent;
  max-width: 100%;
  /* margin-top: 32px; */
  box-shadow: none;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .arrow {
  display: none;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title {
  height: 84px;
  background-color: #f2f3f5;
  padding: 26px 70px 26px 26px;
  font-size: 54px;
  border: 0;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-hours {
  font-size: 54px;
  color: #000000;
  opacity: 0.3;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title .clockpicker-span-hours.text-primary {
  opacity: 1;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title .clockpicker-span-minutes.text-primary {
  opacity: 1;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-minutes {
  font-size: 54px;
  color: #000000;
  opacity: 0.3;
}

.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-title {
  height: 84px;
  background-color: #2e2c34;
  padding: 26px 70px 26px 26px;
  font-size: 54px;
}

.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-hours {
  font-size: 54px;
  color: #ffffff;
}

.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-minutes {
  font-size: 54px;
  color: #ffffff;
}

.kore-chat-window .hide .clockPickerContainer .confirmBTN {
  opacity: 0;
}

.kore-chat-window.hide .clockPickerContainer .confirmBTN {
  opacity: 0;
}

.kore-chat-window .clockPickerContainer .confirmBTN {
  position: absolute;
  height: 54px;
  background: #009dab;
  bottom: 0;
  width: 100%;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  opacity: 1;
  line-height: 54px;
  transition: opacity 1.5s ease-in-out;
  -moz-transition: opacity 1.5s ease-in-out;
  -webkit-transition: opacity 1.5s ease-in-out;
}

.kore-chat-window.darkTheme .clockPickerContainer .confirmBTN {
  background: #0047cc;
}

.kore-chat-window .clockPickerContainer .headerClock {
  height: 56px;
  padding: 17px;
  position: relative;
}

.kore-chat-window .clockPickerContainer .headerClock .choose {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
}

.kore-chat-window .clockPickerContainer .headerClock .closeButton {
  cursor: pointer;
  color: #aaaaaa;
  background: none;
  border: none;
  opacity: 1;
  outline: none;
  font-size: 30px;
  float: right;
  line-height: inherit;
  margin-top: 5px;
  padding: 0 6px;
  position: absolute;
  right: 10px;
  top: 5px;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.am-button,
.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.pm-button {
  margin-left: 0;
  padding: 3px;
  border: 0;
  border-radius: 4px;
  display: flex;
  background: transparent;
  color: #000000;
}

.darkTheme.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.am-button,
.darkTheme.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.pm-button {
  color: #ffffff;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-am-pm-block {
  right: 0;
  position: absolute;
  top: 0;
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.kore-chat-window .clockPickerContainer {
  padding-bottom: 54px;
  position: relative;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-span-am-pm {
  display: none;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-content {
  background-color: transparent;
}

.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-content .clockpicker-plate {
  width: 196px;
  height: 196px;
  margin: 0 auto;
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
}

.kore-chat-window .clockPickerContainer #clockPickerInput .hide {
  display: none;
}

.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-content .clockpicker-plate {
  background-color: #2e2c34;
  border: 1px solid #2e2c34;
}

/* ClockPicker CSS end */`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/clockPicker/clockPicker.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA;EACI,UAAA;AACJ;;AACA;EACI,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAEJ;;AAAA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAGJ;;AADA;EACI,aAAA;AAIJ;;AAFA;EACI,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,SAAA;AAKJ;;AAHA;EACI,eAAA;EACA,cAAA;EACA,YAAA;AAMJ;;AAJA;EACI,UAAA;AAOJ;;AALA;EACI,UAAA;AAQJ;;AANA;EACI,eAAA;EACA,cAAA;EACA,YAAA;AASJ;;AAPA;EACI,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;AAUJ;;AARA;EACI,eAAA;EACA,cAAA;AAWJ;;AATA;EACI,eAAA;EACA,cAAA;AAYJ;;AAVA;EACI,UAAA;AAaJ;;AAXA;EACI,UAAA;AAcJ;;AAZA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,oCAAA;EACA,yCAAA;EACA,4CAAA;AAeJ;;AAbA;EACI,mBAAA;AAgBJ;;AAdA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AAiBJ;;AAfA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AAkBJ;;AAhBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAmBJ;;AAjBA;;EAEI,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AAoBJ;;AAlBA;;EAEI,cAAA;AAqBJ;;AAnBA;EACI,QAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAsBJ;;AApBA;EACI,oBAAA;EACA,kBAAA;AAuBJ;;AArBA;EACI,aAAA;AAwBJ;;AAtBA;EACI,6BAAA;AAyBJ;;AAvBA;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;AA0BJ;;AAxBA;EACI,aAAA;AA2BJ;;AAzBA;EACI,yBAAA;EACA,yBAAA;AA4BJ;;AA1BA,wBAAA","sourcesContent":["/* ClockPicker CSS start */\n.kore-chat-window .clockPickerContainer .sdkFooterIcon.clock {\n    opacity: 0;\n}\n.kore-chat-window .sdkFooterIcon.clock .sdkClock.clockBtn .clock {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGlkPSJMYXllcl8xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA2NCA2NDsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMxMzQ1NjM7fQo8L3N0eWxlPjxnPjxnIGlkPSJJY29uLUNsb2NrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNzguMDAwMDAwLCA0MjguMDAwMDAwKSI+PHBhdGggY2xhc3M9InN0MCIgZD0iTS0zNDYuMS0zNzMuMWMtMTIuNiwwLTIyLjktMTAuMy0yMi45LTIyLjljMC0xMi42LDEwLjMtMjIuOSwyMi45LTIyLjkgICAgIGMxMi42LDAsMjIuOSwxMC4zLDIyLjksMjIuOUMtMzIzLjEtMzgzLjQtMzMzLjQtMzczLjEtMzQ2LjEtMzczLjFMLTM0Ni4xLTM3My4xeiBNLTM0Ni4xLTQxNi41Yy0xMS4zLDAtMjAuNCw5LjItMjAuNCwyMC40ICAgICBzOS4yLDIwLjQsMjAuNCwyMC40czIwLjQtOS4yLDIwLjQtMjAuNFMtMzM0LjgtNDE2LjUtMzQ2LjEtNDE2LjVMLTM0Ni4xLTQxNi41eiIgaWQ9IkZpbGwtMTMxIi8+PHBvbHlsaW5lIGNsYXNzPSJzdDAiIGlkPSJGaWxsLTEzMiIgcG9pbnRzPSItMzM4LjksLTM4NC4zIC0zNDcuNCwtMzkyLjggLTM0Ny40LC00MDguMyAtMzQ0LjcsLTQwOC4zIC0zNDQuNywtMzkzLjkgICAgICAtMzM3LC0zODYuMiAtMzM4LjksLTM4NC4zICAgICIvPjwvZz48L2c+PC9zdmc+\");\n    background-size: 100% 100%;\n    width: 21px;\n    height: 21px;\n    margin: -4px;\n    display: block;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover {\n    width: 100%;\n    position: relative;\n    top: auto;\n    left: auto;\n    margin: 0 auto;\n    border: 0;\n    background: transparent;\n    max-width: 100%;\n    /* margin-top: 32px; */\n    box-shadow: none;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .arrow {\n    display: none;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title {\n    height: 84px;\n    background-color: #f2f3f5;\n    padding: 26px 70px 26px 26px;\n    font-size: 54px;\n    border: 0;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-hours {\n    font-size: 54px;\n    color: #000000;\n    opacity: 0.3;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title .clockpicker-span-hours.text-primary {\n    opacity: 1;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title .clockpicker-span-minutes.text-primary {\n    opacity: 1;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-minutes {\n    font-size: 54px;\n    color: #000000;\n    opacity: 0.3;\n}\n.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-title {\n    height: 84px;\n    background-color: #2e2c34;\n    padding: 26px 70px 26px 26px;\n    font-size: 54px;\n}\n.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-hours {\n    font-size: 54px;\n    color: #ffffff;\n}\n.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-title span.clockpicker-span-minutes {\n    font-size: 54px;\n    color: #ffffff;\n}\n.kore-chat-window .hide .clockPickerContainer .confirmBTN {\n    opacity: 0;\n}\n.kore-chat-window.hide .clockPickerContainer .confirmBTN {\n    opacity: 0;\n}\n.kore-chat-window .clockPickerContainer .confirmBTN {\n    position: absolute;\n    height: 54px;\n    background: #009dab;\n    bottom: 0;\n    width: 100%;\n    text-align: center;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    opacity: 1;\n    line-height: 54px;\n    transition: opacity 1.5s ease-in-out;\n    -moz-transition: opacity 1.5s ease-in-out;\n    -webkit-transition: opacity 1.5s ease-in-out;\n}\n.kore-chat-window.darkTheme .clockPickerContainer .confirmBTN {\n    background: #0047cc;\n}\n.kore-chat-window .clockPickerContainer .headerClock {\n    height: 56px;\n    padding: 17px;\n    position: relative;\n}\n.kore-chat-window .clockPickerContainer .headerClock .choose {\n    font-size: 20px;\n    font-weight: bold;\n    color: #000000;\n}\n.kore-chat-window .clockPickerContainer .headerClock .closeButton {\n    cursor: pointer;\n    color: #aaaaaa;\n    background: none;\n    border: none;\n    opacity: 1;\n    outline: none;\n    font-size: 30px;\n    float: right;\n    line-height: inherit;\n    margin-top: 5px;\n    padding: 0 6px;\n    position: absolute;\n    right: 10px;\n    top: 5px;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.am-button,\n.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.pm-button {\n    margin-left: 0;\n    padding: 3px;\n    border: 0;\n    border-radius: 4px;\n    display: flex;\n    background: transparent;\n    color: #000000;\n}\n.darkTheme.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.am-button,\n.darkTheme.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-button.pm-button {\n    color: #ffffff;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-am-pm-block {\n    right: 0;\n    position: absolute;\n    top: 0;\n    width: 60%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n}\n.kore-chat-window .clockPickerContainer {\n    padding-bottom: 54px;\n    position: relative;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .clockpicker-span-am-pm {\n    display: none;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-content {\n    background-color: transparent;\n}\n.kore-chat-window .clockPickerContainer .clockpicker-popover .popover-content .clockpicker-plate {\n    width: 196px;\n    height: 196px;\n    margin: 0 auto;\n    background-color: #eeeeee;\n    border: 1px solid #eeeeee;\n}\n.kore-chat-window .clockPickerContainer #clockPickerInput .hide {\n    display: none;\n}\n.kore-chat-window.darkTheme .clockPickerContainer .clockpicker-popover .popover-content .clockpicker-plate {\n    background-color: #2e2c34;\n    border: 1px solid #2e2c34;\n}\n/* ClockPicker CSS end */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
